import type { ActionGraph } from "../actions.ts";
import type { Item, ProjectView } from "../entities.ts";
import { validateGraphEdges } from "./edges.ts";
import { validateEntryPoints, validateOrphanNodes } from "./entryPoints.ts";
import { validateNode, validateNodeInputs } from "./nodes.ts";
import { validatePlayerRequiredReachability } from "./playerReachability.ts";
import type { UiNodeLike, ValidationReport } from "./types.ts";

export const walkGraph = (
	graph: ActionGraph | null | undefined,
	view: ProjectView,
	entityId: string,
	item: Item,
	report: ValidationReport,
): void => {
	if (!graph) return;
	validateEntryPoints(graph, item, view, entityId, report);
	for (const node of Object.values(graph.nodes)) {
		validateNode(node, view, entityId, report);
	}
	validateGraphEdges(graph, entityId, report);
	validateNodeInputs(graph, entityId, report);
	validateOrphanNodes(graph, entityId, report);
	validatePlayerRequiredReachability(graph, item, view, entityId, report);
};

export const walkUiNode = (
	node: UiNodeLike,
	view: ProjectView,
	treeId: string,
	report: ValidationReport,
): void => {
	const graph = node.graph;
	if (graph) {
		for (const inner of Object.values(graph.nodes)) {
			validateNode(inner, view, treeId, report, "uiTrees");
		}
		validateGraphEdges(graph, treeId, report, "uiTrees");
		validateNodeInputs(graph, treeId, report, "uiTrees");
		validateOrphanNodes(graph, treeId, report, {
			entityKind: "uiTrees",
			allowReactiveUiConsumers: true,
		});
	}
	const children = node.children ?? [];
	for (const child of children) {
		walkUiNode(child, view, treeId, report);
	}
};
